// frontend/pages/HrEmployeeDashboard.jsx
import React, { useMemo, useState } from "react";
import { User, Clock, Sun, CalendarDays } from "lucide-react";
import HrEmployeeProfileTab from "../components/HrEmployeeProfileTab.jsx";
import HrEmployeeTimeTab from "../components/HrEmployeeTimeTab.jsx";
import HrEmployeeVacationsTab from "../components/HrEmployeeVacationsTab.jsx";
import HrEmployeeCalendarTab from "../components/HrEmployeeCalendarTab.jsx";
import PageHeader from "./PageHeader.jsx";
import "../styles/hr/hremployeedashboard.css";

const TABS = [
  { id: "profile", label: "Perfil", icon: User },
  { id: "time", label: "Fichajes", icon: Clock },
  { id: "vacations", label: "Vacaciones", icon: Sun },
  { id: "calendar", label: "Calendario anual", icon: CalendarDays },
];

const TAB_COMPONENTS = {
  profile: HrEmployeeProfileTab,
  time: HrEmployeeTimeTab,
  vacations: HrEmployeeVacationsTab,
  calendar: HrEmployeeCalendarTab,
};

const HrEmployeeDashboard = () => {
  const [activeTab, setActiveTab] = useState("profile");

  const ActiveTabComponent = useMemo(() => {
    return TAB_COMPONENTS[activeTab] || null;
  }, [activeTab]);

  return (
    <div className="hr-employee-dashboard">
      <div className="hr-employee-header">
        <div>
          <h1 className="hr-employee-title"><PageHeader title="Panel de empleado" /></h1>
          <p className="hr-employee-subtitle">
            Tu espacio para consultar perfil, fichajes, vacaciones y calendario anual.
          </p>
        </div>
      </div>

      <div className="hr-tabs" role="tablist" aria-label="Secciones de empleado">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              id={`hr-tab-${tab.id}`}
              type="button"
              className={`hr-tab-button ${isActive ? "hr-tab-button--active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
              role="tab"
              aria-selected={isActive}
              aria-controls={`hr-panel-${tab.id}`}
            >
              <Icon className="hr-tab-icon" aria-hidden="true" />
              <span className="hr-tab-label">{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div
        className="hr-tab-content"
        role="tabpanel"
        id={`hr-panel-${activeTab}`}
        aria-labelledby={`hr-tab-${activeTab}`}
      >
        {ActiveTabComponent ? <ActiveTabComponent /> : null}
      </div>
    </div>
  );
};

export default HrEmployeeDashboard;